<template>
    <div>
        <div name="query-sort-block" class="mt10">
            <swb-query-sort-area ref="query_model_ctrl" class="mb10" :config="queryConfig" :queryOnLoad="true" :queryHandler="queryHandler"></swb-query-sort-area>
        </div>
        <div v-if="checkBox" class="table-layout">
            <el-table ref="mkuList" :data="mkuList" border style="width: 100%" @selection-change="handleSelectionChange">
                <el-table-column v-if="checkBox" :selectable="selectable" align="center" type="selection" width="55"></el-table-column>
                <el-table-column align="left" width="100" prop="skuId" label="SKUID" show-overflow-tooltip></el-table-column>
                <el-table-column align="center" prop="albumImg" label="图片" width="100">
                    <template slot-scope="scope">
                        <div v-if="scope.row.sku != null">
                            <img class="wh100" v-if="scope.row.sku.defaultImageUrl != null && scope.row.sku.defaultImageUrl != ''" :src="scope.row.sku.defaultImageUrl"/>
                            <img class="wh100" v-resc-url="'/image/noimg.jpg'" v-else/>
                        </div>
                        <img class="wh100" v-resc-url="'/image/noimg.jpg'" v-else/>
                    </template>
                </el-table-column>
                <el-table-column align="left" prop="title" label="商品名称" show-overflow-tooltip></el-table-column>
                <el-table-column prop="cccFlag" label="是否3C" align="center" width="100">
                    <template slot-scope="scope">
                        <el-tag type="success" v-if="scope.row.cccFlag" close-transition>是</el-tag>
                        <el-tag type="danger" v-if="!scope.row.cccFlag" close-transition>否</el-tag>
                    </template>
                </el-table-column>
                <el-table-column align="left" label="SKU商家编码" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span>{{scope.row.sku.no}}</span>
                    </template>
                </el-table-column>
                <el-table-column align="left" prop="model" label="型号" show-overflow-tooltip></el-table-column>
                <el-table-column align="left" prop="fixedSpec" label="规格" show-overflow-tooltip></el-table-column>
                <el-table-column align="left" prop="catName" label="分类" show-overflow-tooltip></el-table-column>
                <el-table-column align="left" prop="brandName" label="品牌" show-overflow-tooltip></el-table-column>
                <el-table-column prop="shelfState" label="是否上架" align="center" width="100">
                    <template slot-scope="scope">
                        <el-tag type="danger" v-if="scope.row.shelfState==0" close-transition>未上架</el-tag>
                        <el-tag type="success" v-if="scope.row.shelfState==1" close-transition>已上架</el-tag>
                        <el-tag type="danger" v-if="scope.row.shelfState==-1" close-transition>已下架</el-tag>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="table-layout" v-else>
            <el-table :data="mkuList" border style="width: 100%" highlight-current-row @current-change="handleCurrentChange">
                <el-table-column width="55">
                    <template slot-scope="rows">
                        <div class="copy-radio" :class="{'circle' : checlMkuInfo!= null && checlMkuInfo.id == rows.row.id}">
                            <div class="circle-dot"></div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column align="left" width="100" prop="skuId" label="SKUID" show-overflow-tooltip></el-table-column>
                <el-table-column align="center" prop="albumImg" label="图片" width="100">
                    <template slot-scope="scope">
                        <div v-if="scope.row.sku != null">
                            <img class="wh100" v-if="scope.row.sku.defaultImageUrl != null && scope.row.sku.defaultImageUrl != ''" :src="scope.row.sku.defaultImageUrl"/>
                            <img class="wh100" v-resc-url="'/image/noimg.jpg'" v-else/>
                        </div>
                        <img class="wh100" v-resc-url="'/image/noimg.jpg'" v-else/>
                    </template>
                </el-table-column>
                <el-table-column align="left" prop="title" label="商品名称" show-overflow-tooltip></el-table-column>
                <el-table-column prop="cccFlag" label="是否3C" align="center" width="100">
                    <template slot-scope="scope">
                        <el-tag type="success" v-if="scope.row.cccFlag" close-transition>是</el-tag>
                        <el-tag type="danger" v-if="!scope.row.cccFlag" close-transition>否</el-tag>
                    </template>
                </el-table-column>
                <el-table-column align="left" label="SKU商家编码" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span>{{scope.row.sku.no}}</span>
                    </template>
                </el-table-column>
                <el-table-column align="left" prop="model" label="型号" show-overflow-tooltip></el-table-column>
                <el-table-column align="left" prop="fixedSpec" label="规格" show-overflow-tooltip></el-table-column>
                <el-table-column align="left" prop="catName" label="分类" show-overflow-tooltip></el-table-column>
                <el-table-column align="left" prop="brandName" label="品牌" show-overflow-tooltip></el-table-column>
                <el-table-column prop="shelfState" label="是否上架" align="center" width="100">
                    <template slot-scope="scope">
                        <el-tag type="danger" v-if="scope.row.shelfState==0" close-transition>未上架</el-tag>
                        <el-tag type="success" v-if="scope.row.shelfState==1" close-transition>已上架</el-tag>
                        <el-tag type="danger" v-if="scope.row.shelfState==-1" close-transition>已下架</el-tag>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="block pagination-layout">
            <el-pagination background class="mt10" :page-size="pageSize" :page-sizes="pageSizes" :current-page="pageNumber" :total="totalCount" @current-change="handlePageChange" @size-change="handleSizeChange" layout="total, sizes, prev, pager, next, jumper"></el-pagination>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox } from '../../app.vues'
    import { getDefaultPageSizes } from '../../../src/app.conf'

    import goodsApi from '../../api/goods'

    import SwbResultColConf from '../query/ResultColConf.vue';

    Vue.regist(SwbResultColConf);

    let queryConfig = {
        //查询项配置
        queryFields: [
            {
                "code": "title",
                "label": "商品名称",
                "type": "Text",
                "valueType": "String",
                "basic": true,
                "hidden": false
            },
            {
                "code": "catName",
                "label": "分类",
                "type": "Text",
                "valueType": "String",
                "basic": true,
                "hidden": false
            },
            {
                "code": "brandName",
                "label": "品牌",
                "type": "Text",
                "valueType": "String",
                "basic": true,
                "hidden": false
            },
            {
                "code": "model",
                "label": "型号",
                "type": "Text",
                "valueType": "String",
                "basic": true,
                "hidden": false
            },
            {
                "code": "fixedSpec",
                "label": "规格",
                "type": "Text",
                "valueType": "String",
                "basic": true,
                "hidden": false
            }
        ],
        //排序项配置
        sortFields: [],
        //基本区域最大单元数量
        basicMaxSpaces: 8
    };

    export default {
        name: 'swb-sku-list-for-select',
        desc: 'sku选择列表',
        props: {
            checkBox: {
                type: Boolean,
                default: true
            },
            filter: {
                type: Object,
                default: function () {
                    return {};
                }
            },
            skuIds: {// 多选的时候传入
                type: Array,
                default: function () {
                    return [];
                }
            },
            needDisabled: {
                type: Boolean,
                default: true
            }
        },
        data: function () {
            return {
                totalCount: 0,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),
                pageNumber: 1,
                //
                mkuList: [],
                checlMkuInfo: null,
                title: null,
                //复选信息
                checkedIdsX: [],
                checkedIdMap: {},
                checkedDelay: 100,
                checkedIniting: false,
                checkedTblRefId: 'mkuList',
                checkedList: [],
                // 过滤信息
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {}
                },
                queryConfig: queryConfig,
            }
        },
        created: function () {
            let self = this;
            self.pageSize = self.pageSizes.first();
            //
//            self.getMkuPageList();
        },
        methods: {
            queryHandler: function (queryModel) {
                this.queryModel = queryModel;
                this.pageNumber = 1;
                this.getMkuPageList();
            },
            // ===================== 分页多选开始 ==============================
            addCheckId: function (id, val) {
                if(!this.checkedIdsX.contains(id)) {
                    this.checkedIdsX.add(id);
                    this.checkedList.add(val);
                    return id;
                }
                return null;
            },
            delCheckId: function (id) {
                let self = this;
                if(self.checkedIdsX.contains(id)) {
                    for(let i = 0; i < self.checkedList.length; i++) {
                        let checkedMku = self.checkedList[i];
                        if(checkedMku.skuId == id) {
                            self.checkedList.splice(i, 1);
                        }
                    }
                    self.checkedIdsX.remove(id);
                    return id;
                }
                return null;
            },
            handleSelectionChange: function (selRows) {
                let self = this;
                if(self.checkedIniting) {
                    return;
                }
                let allIds = self.mkuList.pluck("skuId");
                let selIds = selRows.pluck("skuId");
                selIds.forEach(function (id, index) {
                    self.addCheckId(id, selRows[index]);
                });

                let lesIds = Utils.compareArrays(selIds, allIds)["less"];
                lesIds.forEach(function (id, index) {
                    self.delCheckId(id);
                });
            },
            restoreSelRows(dataRows, tblRefId, idProp){
                let self = this;
                self.checkedIniting = true;
                idProp = idProp || "id";
                let allIds = dataRows.pluck(idProp);
                let selIds = Utils.compareArrays(allIds, this.checkedIdsX)["same"];
                selIds.forEach(function (id) {
                    self.toggleListRowById(dataRows, tblRefId, idProp, id);
                });
                //
                self.checkedIniting = false
            },

            hashCheckedId(id){
                return this.checkedIdsX.contains(id);
            },

            toggleListRowById(dataRows, tblRefId, idProp, idVal){
                let self = this;
                //
                idProp = idProp || "id";
                let refTbl = self.$refs[tblRefId];
                let theRow = dataRows.find(function (row, idx) {
                    return row[idProp] == idVal;
                });
                if(theRow != null) {
                    refTbl.toggleRowSelection(theRow);
                }
            },

            // ===================== 分页多选结束 ==============================

            handleSizeChange: function (val) {
                let curStartIndex = (this.pageNumber - 1) * this.pageSize;
                this.pageSize = val;
                let newPageNumber = Math.max(1, Math.ceil(curStartIndex / this.pageSize));
                this.handlePageChange(newPageNumber);
            },
            handlePageChange: function (val) {
                if(this.checkedIniting) {
                    return;
                } else {
                    this.checkedIniting = true;
                }
                this.pageNumber = val;
                this.getMkuPageList();
            },
            getMkuPageList: function () {
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                let queryModel = self.queryModel;
                let filterItems = Utils.merge({}, queryModel.filterItems);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);

                let filter = self.filter || {};
                let filterItem = Object.assign(filterItems, filter);
                //
                postData.filterItems = filterItem;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                let theLoad = MsgBox.loading();
                goodsApi.getMkuPagedList(postData, function (result) {
                    theLoad.hide();
                    if(result.type == "info") {
                        let data = result.data;
                        let mkuList = data.rows;
                        //
                        self.mkuList = Utils.merge([], mkuList);
                        self.totalCount = data.pagination.totalCount;
                        //
                        setTimeout(function () {
                            self.restoreSelRows(self.mkuList, self.checkedTblRefId, 'skuId');
                        }, self.checkedDelay);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            selectable: function (row, index) {
                let skuIds = this.skuIds;
                if(skuIds.indexOf(row.skuId) >= 0) {
                    //this.$refs['mkuList'].toggleRowSelection(row);
                    return false;
                } else {
                    return true;
                }
            },
            handleCurrentChange: function (val) {
                this.checlMkuInfo = Utils.merge({}, val);
            },
            getSkuInfo: function (mkuInfo) {
                let skuInfo = {};
                if(mkuInfo != null) {
                    skuInfo.id = mkuInfo.skuId;
                    skuInfo.goodsId = mkuInfo.goodsId;
                    skuInfo.mkuId = mkuInfo.id;
                    skuInfo.title = mkuInfo.title;
                    skuInfo.costPrice = mkuInfo.costPrice;
                    skuInfo.wholePrice = mkuInfo.wholePrice;
                    skuInfo.salePrice = mkuInfo.salePrice;
                    skuInfo.shelfState = mkuInfo.shelfState;
                    skuInfo.packList = mkuInfo.packList;
                    skuInfo.merchantId = mkuInfo.merchantId;
                    skuInfo.merchantType = mkuInfo.merchantType;
                    skuInfo.vendorType = mkuInfo.vendorType;
                    skuInfo.unit = mkuInfo.unit;
                    skuInfo.wrntPeriod = mkuInfo.wrntPeriod;
                    skuInfo.priceNegoFlag = mkuInfo.priceNegoFlag;
                    skuInfo.catId = mkuInfo.catId;
                    skuInfo.catName = mkuInfo.catName;
                    skuInfo.model = mkuInfo.model;
                    skuInfo.fixedSpec = mkuInfo.fixedSpec;
                    if(mkuInfo.sku != null) {
                        skuInfo.brandId = mkuInfo.sku.brandId;
                        skuInfo.brandName = mkuInfo.sku.brandName;
                        skuInfo.defaultImageUrl = mkuInfo.sku.defaultImageUrl;
                        skuInfo.customized = mkuInfo.sku.customized;
                    }
                }
                return skuInfo;
            },
            getSkuList: function () {
                let skuList = [];
                let mkuList = this.checkedList;
                if(mkuList != null && mkuList.length > 0) {
                    for(let i = 0; i < mkuList.length; i++) {
                        let mkuInfo = mkuList[i];
                        let skuInfo = this.getSkuInfo(mkuInfo);
                        skuList.push(skuInfo);
                    }
                }
                return skuList;
            },
            getDlgResult: function () {
                let self = this;
                let result = {};
                //
                let checkBox = self.checkBox;
                if(checkBox) {
                    let mkuList = self.checkedList;
                    if(mkuList != null && mkuList.length > 0) {
                        result.type = "info";
                        result.data = self.getSkuList();
                    } else {
                        result.type = 'warn';
                        result.message = '至少选择一个商品！';
                    }
                } else {
                    let mkuInfo = self.checlMkuInfo;
                    if(mkuInfo != null) {
                        result.type = "info";
                        result.data = self.getSkuInfo(mkuInfo);
                    } else {
                        result.type = 'warn';
                        result.message = '请选择一个商品！';
                    }
                }
                return result;
            }
        }
    }
</script>




// WEBPACK FOOTER //
// src/compo/goods/SkuListForSelect.vue